import { Routes } from '@angular/router';
import { shipmentResolver } from './features/shipping-method/resolvers/shipment-resolver';
import { complianceResolver } from './features/compliance-flow/resolvers/compliance-resolver';
import { NotFound } from './shared/components/errors-components/not-found';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'shipment/',
    pathMatch: 'full',
  },
  {
    path: 'txc',
    loadChildren: () =>
      import('./features/compliance-flow/compliance-flow.routes').then(
        (m) => m.complianceFlowRoutes
      ),
  },
  {
    path: `shipment/:id`,
    loadChildren: () =>
      import('./features/shipping-method/shipping-method.routes').then(
        (m) => m.shippingMethodRoutes
      ),
    resolve: { shipmentInfo: shipmentResolver },
    runGuardsAndResolvers: 'paramsChange',
  },
  {
    path: `txc/:id`,
    loadChildren: () =>
      import('./features/compliance-flow/compliance-flow.routes').then(
        (m) => m.complianceFlowRoutes
      ),
    resolve: { shipmentInfo: complianceResolver },
    runGuardsAndResolvers: 'paramsChange',
  },
  {
    path: 'tracking/:shipmentNumber',
    data: { hasNoBack: true },
    loadComponent: () =>
      import('./features/shipping-method/components/tracking-page/tracking-page').then(
        (m) => m.TrackingPage
      ),
  },

  { path: '404', component: NotFound, data: { hasNoBack: true } },

  { path: '**', redirectTo: '404' },
];
